import { 
  LayoutDashboard, 
  Users, 
  CreditCard, 
  Settings,
  BarChart3,
  Globe,
  MousePointer,
  TrendingUp
} from 'lucide-react';

const navItems = [
  { id: 'overview', label: 'Overview', icon: LayoutDashboard },
  { id: 'visitors', label: 'Visitors', icon: Users },
  { id: 'traffic', label: 'Traffic Sources', icon: Globe },
  { id: 'pages', label: 'Pages', icon: MousePointer },
  { id: 'conversions', label: 'Registrations', icon: TrendingUp },
  { id: 'reports', label: 'Reports', icon: BarChart3 },
];

const bottomNavItems = [
  { id: 'settings', label: 'Settings', icon: Settings },
];

export const Sidebar = ({ activeTab = 'overview', onTabChange }) => {
  return (
    <aside 
      className="fixed left-0 top-0 h-screen w-64 bg-card/90 backdrop-blur-xl border-r border-white/5 z-50 hidden lg:flex flex-col"
      data-testid="sidebar"
    >
      {/* Logo */}
      <div className="p-6 border-b border-white/5">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary to-primary/60 flex items-center justify-center">
            <BarChart3 className="w-5 h-5 text-primary-foreground" />
          </div>
          <div>
            <h2 className="font-playfair text-lg font-medium text-foreground">The Reset</h2>
            <p className="text-xs text-muted-foreground font-manrope">Analytics</p>
          </div>
        </div>
      </div>
      
      {/* Main navigation */}
      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          
          return (
            <button
              key={item.id}
              onClick={() => onTabChange(item.id)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg font-manrope text-sm transition-all duration-200 ${
                isActive 
                  ? 'bg-primary/10 text-primary border border-primary/20' 
                  : 'text-muted-foreground hover:text-foreground hover:bg-white/5'
              }`}
              data-testid={`nav-${item.id}`}
            >
              <Icon className={`w-5 h-5 ${isActive ? 'text-primary' : ''}`} />
              <span>{item.label}</span>
              {isActive && (
                <div className="ml-auto w-1.5 h-1.5 rounded-full bg-primary" />
              )}
            </button>
          );
        })}
      </nav>
      
      {/* Bottom navigation */}
      <div className="p-4 border-t border-white/5">
        {bottomNavItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          
          return (
            <button
              key={item.id}
              onClick={() => onTabChange(item.id)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg font-manrope text-sm transition-all duration-200 ${
                isActive 
                  ? 'bg-primary/10 text-primary border border-primary/20' 
                  : 'text-muted-foreground hover:text-foreground hover:bg-white/5'
              }`}
              data-testid={`nav-${item.id}`}
            >
              <Icon className={`w-5 h-5 ${isActive ? 'text-primary' : ''}`} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </aside>
  );
};

// Mobile navigation
export const MobileNav = ({ activeTab, onTabChange }) => {
  const visibleItems = navItems.slice(0, 5);
  
  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 bg-card/95 backdrop-blur-xl border-t border-white/5 z-50 lg:hidden"
      data-testid="mobile-nav"
    >
      <div className="flex items-center justify-around px-2 py-2">
        {visibleItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          
          return (
            <button
              key={item.id}
              onClick={() => onTabChange(item.id)}
              className={`flex flex-col items-center gap-1 p-2 rounded-lg transition-all duration-200 ${
                isActive ? 'text-primary' : 'text-muted-foreground'
              }`}
              data-testid={`mobile-nav-${item.id}`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-[10px] font-manrope">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
